import { showTooltip, hideTooltip } from "./BootstrapApi";

export const copy = (id, text) => {
    navigator.clipboard.writeText(text.trim())
    showTooltip(id, '¡Copiado!', false, 'click')
    setTimeout(() => {
        hideTooltip(id)
    }, 1000);
}
